var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCruise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "82231106-154B-4FD4-851B-33A8CBC24CFE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-40.6%",
    y: "-40.6%",
    width: "181.2%",
    height: "181.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Final-Template-Arun",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Campaign-Manager---Auto-1.0",
    transform: "translate(-60.000000, -175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-271",
    filter: "url(#filter-1)",
    transform: "translate(65.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#A4DF23",
    strokeWidth: 2,
    fill: "#0A72BA",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1002705,5.9375 L17.7728197,5.9375 L19.3703015,1.12070312 C19.5202998,0.556640625 19.0890547,0 18.5003114,0 L13.1003728,0 C12.6503779,0 12.2678823,0.330273437 12.2078829,0.771875 L11.0078966,9.678125 C10.9366474,10.2125 11.3566426,10.6875 11.9003864,10.6875 L16.3515858,10.6875 L14.6228555,17.9052734 C14.487857,18.4693359 14.9228521,19 15.4965956,19 C15.807842,19 16.1115886,18.8367187 16.2765867,18.5546875 L22.8765117,7.2734375 C23.2252577,6.68339844 22.7940126,5.9375 22.1002705,5.9375 Z M16.8746988,16 L18.0855422,10.7542603 L18.4216867,9.29464065 L13,9.29464065 L14.0807229,1 L18.6313253,1 L17.2325301,5.37144974 L16.7337349,6.92738948 L22,6.92738948 L16.8746988,16 Z",
    id: "Shape",
    fill: "#A4DF23",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-253",
    transform: "translate(5.000000, 18.000000)",
    fill: "#FFFFFF",
    fontFamily: "RobotoCondensed-Bold, Roboto Condensed",
    fontSize: 8,
    fontStyle: "condensed",
    fontWeight: "bold",
    letterSpacing: 0.15625
  }, /*#__PURE__*/React.createElement("text", {
    id: "Cruise"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.716796875,
    y: 7
  }, "Cruise"))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruise);
export default __webpack_public_path__ + "static/media/cruise.898675a0.svg";
export { ForwardRef as ReactComponent };